module.exports = __webpack_public_path__ + "img/top-bar.eb016027.png";